import { Molecule, wrap, Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';
import { IconFromUrl, Icon, SecondaryTextXs } from 'atoms';
import { Mr2, FlexCenterWrapper, Mr14 } from 'wrappers';
import { GreenTickSvg } from 'components/icons';

const template = styled.div`
  ${({ theme, displayState }) => css`
    padding-left: 24px;
    padding-right: 24px;
    height: 41px;
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    background: ${displayState?.isSelected ? (`${theme?.colour?.primary}0D` ?? '#F4FCF8') : ''};

    &:hover {
      background: ${`${theme?.colour?.primary}0D` ?? '#F4FCF8'};
      font-weight: 600;
    }

    svg {
      fill: ${displayState?.iconColor ?? ''}
    }
`}
`;

const TickWrapper = Wrapper(styled.div`svg {fill: none}`)

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      wrapper: wrap(FlexCenterWrapper, Mr14),
      name: 'LeftSideWrapper',
      atoms: [
        {
          component: wrap(IconFromUrl, Mr2),
          name: 'Icon',
          renderIf: ({ image }) => !!image,
          displayValue: ({ image }) => image,
          displayState: ({ }) => ({ width: '16px', height: '16px' })
        },
        {
          component: wrap(Icon, Mr2),
          name: 'Icon',
          renderIf: ({ icon }) => !!icon,
          displayValue: ({ icon }) => icon
        },
        {
          component: SecondaryTextXs,
          name: 'Name',
          displayValue: ({ text }) => text
        },
      ]
    },
    {
      component: wrap(Icon, TickWrapper),
      name: 'Icon',
      renderIf: ({ isSelected }) => isSelected,
      displayValue: ({ }) => GreenTickSvg({})
    },
  ]
})